export type ProgressState = 'pending' | 'success' | 'error';

export interface ProgressElement {
  state: ProgressState;
  messageTranslateKey: string;
  progress?: number;
}
